export default __webpack_public_path__ + "images/0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270.png";